module.exports = __webpack_public_path__ + "img/aparatos_electronicos.bd98744a.png";